import { createAsyncThunk } from '@reduxjs/toolkit'
import { PaginatedData } from '../../../../shared/types/PaginatedData'
import { ThunkConfig } from '../../../../shared/config/storeConfig/StoreSchema'
import { addQueryParams } from '../../../../shared/lib/addQueryParams/addQueryParams'
import { appHandleError } from '../../../../shared/lib/appHandleError/appHandleError'
import { selectLimit } from '../selectors/selectLimit'
import { selectPage } from '../selectors/selectPage'
import { selectSortValues } from '../selectors/selectSortValues'
import { selectQueryFilter } from '../selectors/selectQueryFilter'
import { IApplication } from '../../../../entities/Application'
import { selectState } from '../selectors/selectState'

export const fetchApps = createAsyncThunk<
	PaginatedData<IApplication>,
	void,
	ThunkConfig<string>
>('applications/fetchApps', async (_, thunkAPI) => {

	const { extra: { api }, rejectWithValue, getState } = thunkAPI

	const page = selectPage(getState())
	const limit = selectLimit(getState())
	const state = selectState(getState())
	const sortValues = selectSortValues(getState())
	const queryFilters = selectQueryFilter(getState())

	const params = { ...queryFilters, ...sortValues, page, state, limit }

	addQueryParams(params)
	try {
		// @ts-ignore
		const response = await api.get<PaginatedData<IApplication>>(
			'/applications',
			{ params }
		)

		if (response.data) {
			response.data.items.forEach((item) => {
				item.creationDate = item.creationDate?.split('T')?.[0]
				item.expirationDate = item.expirationDate?.split('T')?.[0]
			})
		}

		return response.data
	} catch (e) {
		console.log(e)
		appHandleError(e, 'fetchApps', 'Failed to fetch "applications" data')
		return rejectWithValue('Error occurred on fetching applications list')
	}
})